import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgSuccess(props) {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_jsx("path", {
      d: "M59.498 26.678c.746 4.167.907 9.898-1.272 15.322-4.03 10.526-14.238 18-26.193 18C16.551 60 4 47.464 4 32S16.55 4 32.033 4c7.11 0 13.601 2.643 18.543 7",
      stroke: "#7373FF",
      strokeWidth: 3,
      strokeLinecap: "round"
    }, void 0), _jsx("path", {
      d: "M18.56 29.98L31.114 43l24.602-25",
      stroke: "#FF6652",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, void 0)]
  }), void 0);
}

export default SvgSuccess;